import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import ko from './ko'
import tw from "./tw"
import elementZh from 'element-ui/lib/locale/lang/zh-CN';
import elementEn from 'element-ui/lib/locale/lang/en';
import elementTw from 'element-ui/lib/locale/lang/zh-TW';
// import locale from 'element-ui/lib/locale';
import ElementUI from "element-ui";
import { languages } from '@/config';

Vue.use(VueI18n);
const langs = languages; // ['zh-CN', 'en-US', 'zh-TW'];
// 语言切换
function lang() {
    let lang = window.localStorage.getItem('lang') || (navigator.language || navigator.userLanguage);
    if (lang && langs.indexOf(lang) != -1) {
        return lang
    } else {
        return langs[0];
    }
}

// 切换组件语言
Vue.use(ElementUI, {
    size: 'small',
    zIndex: 300,
    i18n: (key, value) => i18n.t(key, value)
});
// 存到本地
localStorage.setItem('lang', lang());
const language = lang();

const _messages = () => {
    let data = {};
    const _lang = {
        'zh-CN': {
            ...zh,
            ...elementZh
        },
        'en-US': {
            ...en,
            ...elementEn
        },
        'zh-TW': {
            ...tw,
            ...elementTw
        },
        'ko': ko
    }
    for (let key in _lang) {
        if (languages.indexOf(key) != -1) {
            data[key] = _lang[key]
        }
    }
    return data
}
export const i18n = new VueI18n({
    locale: language,
    messages: _messages()
});

export function changeLanguage(lang) {
    i18n.locale = lang;
    // store.commit('getInfo');
    localStorage.setItem('lang', lang)
}


// WEBPACK FOOTER //
// ./src/common/language/index.js